import { useEffect, useState, type CSSProperties } from "react";
import type { SeatView } from "../model/table";
/** Public social context is independent of rules labels and gameplay colors. */
export function PublicSeatIdentity({
    seat,
    iconOnly = false,
}: {
    seat: SeatView;
    iconOnly?: boolean;
}) {
    const [failed, setFailed] = useState(false);
    const profile = seat.profile;
    useEffect(() => setFailed(false), [profile?.iconUrl]);
    if (!profile) return iconOnly ? null : <>{seat.label}</>;
    return (
        <>
            <span
                className="public-seat-avatar"
                style={
                    {
                        "--profile-primary": profile.primaryColor,
                        "--profile-secondary": profile.secondaryColor,
                    } as CSSProperties
                }
                aria-hidden="true"
            >
                {profile.iconUrl && !failed ? (
                    <img
                        src={profile.iconUrl}
                        alt=""
                        onError={() => setFailed(true)}
                    />
                ) : (
                    profile.displayName.slice(0, 1).toUpperCase()
                )}
            </span>
            {!iconOnly && (
                <span>
                    {profile.displayName}
                    <small className="public-seat-role"> · {seat.label}</small>
                </span>
            )}
        </>
    );
}
